export default __webpack_public_path__ + "static/media/person.85ee40f0.png";